import { FilterDateType } from "./../../model/domain/MonitorFilter";
import { Ticket } from "../../../app/model/domain/Entity";
import { PagedList } from "../../../app/model/domain/PagedList";
import { Observable } from "rxjs";

export interface ITicketableService<T extends Ticket> {
  registerTicket(ticket: T): Observable<any>;
  updateTicket(id: number, ticket: T): Observable<any>;
  getTicket(id: number): Observable<T>;
  listTicket(
    dateType?: FilterDateType,
    startDate?: Date,
    endDate?: Date,
    statusId?: number,
    operationTypeId?: number,
    settlementTypeId?: number,
    portfolioCode?: string,
    portfolioName?: string,
    portfolioDocument?: string,
    accountManagerId?: number,
    page?: number,
    pageSize?: number
  ): Observable<PagedList<T>>;
  forwardTicket(id: number): Observable<StatusDetails>;
  cancelDraftTicket(id: number): Observable<StatusDetails>;
}

export class StatusDetails {
  statusDescription: string;
}
